import { render, staticRenderFns } from "./followUpBonusReviewSetting.vue?vue&type=template&id=3af94d2b&scoped=true"
import script from "./followUpBonusReviewSetting.vue?vue&type=script&lang=js"
export * from "./followUpBonusReviewSetting.vue?vue&type=script&lang=js"
import style0 from "./followUpBonusReviewSetting.vue?vue&type=style&index=0&id=3af94d2b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3af94d2b",
  null
  
)

export default component.exports